let Params = {
    WEIGHT: (window.innerWidth) + 'px',
    HEIGHT: (window.innerHeight) + 'px',
    SIDEBAR_WIDTH: (window.innerWidth * 80 / 100) + 'px',
    //API_URL: 'http://localhost/med/fastershiplog/system/api/v1/livreurs/',
    API_URL: 'https://tracking.fastershiplog.ma/api/v1/livreurs/',
    USER_TOKEN: localStorage.getItem('om_user_token')
}

let Links = {
    API: `${Params.API_URL}`,
}

export { Params, Links };